import React, { useState } from 'react';
import { createServiceCheckout } from '../lib/callables.js';

export default function ServiceCardPayment({ request }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const pay = async () => {
        setBusy(true); setError('');
        try {
            const { url } = await createServiceCheckout({ requestId: request.id });
            window.location.assign(url);
        } catch (e) { setError(e.message || 'Unable to open checkout. Please try again.'); setBusy(false); }
    };
    if (Number(request.quotedAmount) < 400) return <p className="text-xs text-midnight-muted">Card payments require a quote of at least HK$4. For this smaller quote, use PayMe / FPS or contact Danielle.</p>;
    return <div className="space-y-2">
        <button onClick={pay} disabled={busy || request.paymentReviewRequired} className="px-5 py-3 bg-midnight-accent text-midnight-pageDark font-display text-sm disabled:opacity-50">
            {busy ? 'Opening secure checkout…' : 'Pay by card with Stripe'}
        </button>
        <p className="text-xs text-midnight-muted">One payment for this quote. Confirm your session time or review arrangements with Danielle before paying. Card payments update here automatically after confirmation. If you see a charge, do not pay again.</p>
        {request.paymentReviewRequired && <p className="text-sm text-red-700">Your payment needs checking. Please contact learn@daniellenglish.com.</p>}
        {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    </div>;
}
